<template>
  <div id="results">
    <main>
      <div class="user user-results">
        <div class="left results d-table" v-bind:class="classResults" v-if="this.grade != null">
          <div class="left-contents d-table-cell align-middle position-relative">
            <div class="label-white-large fade-in">
              <GenerateHTML v-for="component in settingsLeftTop" :key="component.name" :component="component"/>
            </div>
            <div class="response">
              <div class="emoticon" v-bind:class="emotionsResults"></div>
              {{ grade }}<small>/10</small>
            </div>
            <GenerateHTML v-for="component in settingsLeftBottom" :key="component.name" :component="component"/>
          </div>
        </div>
      </div>
      <nav class="menu-tips">
        <ul>
          <template v-for="(result, index) in results_html">
            <li><a :href="'#tip-' + (index+1)" v-bind:class="{ 'active': tipActive === '#tip-' + (index+1) }"
                   v-on:click="mouseClick('#tip-' + (index+1))"></a></li>
          </template>
        </ul>
      </nav>
      </nav>
      <div class="right tips">
        <div class="tips">
          <div class="tip" id="tip-0">
            <GenerateHTML v-for="component in settingsRightTop" :key="component.name" :component="component"/>
            <div class="to-tip">
              <div class="label-red">{{ settingsShowTip }}</div>
              <a href="#tip-1" class="button down" v-on:click="mouseClick('#tip-2')">Volgende
                tip</a>
            </div>
          </div>

          <template v-for="(result, index) in results_html">
            <div class="tip" :id="'tip-' + (index + 1)">
              <GenerateHTML v-for="component in result.description" :key="component.name" :component="component"/>
              <div class="to-tip">
                <div class="label-red">{{ settingsNextTip }}</div>
                <a :href="'#tip-' + (index+2)" class="button down" v-on:click="mouseClick('#tip-' + (index+2))">Volgende
                  tip</a>
              </div>
            </div>
          </template>

          <div class="tip" :id="'tip-' + (results_html.length + 1)">
            <GenerateHTML v-for="component in settingsRightBottom" :key="component.name" :component="component"/>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import getGrade from '../mixins/getGrade.js';
import database from '../components/firebaseInit'
import projects from "../../data/projects.json";
import GenerateHTML from "./GenerateHTML";

export default {
  name: 'Results',
  mixins: [getGrade],
  components: {
    GenerateHTML
  },
  data() {
    return {
      grade: null,
      name: null,
      ownGrade: null,
      user_data: [],
      results: [],
      results_html: [],
      uid: this.$route.params.uid,
      env: 'test',
      tipActive: '#tip-1',
      settingsLeftTop: [],
      settingsLeftBottom: [],
      settingsRightTop: [],
      settingsRightBottom: [],
      settingsNextTip: null,
      settingsShowTip: null,
    }
  },
  computed: {
    classResults: function () {
      return {
        'results-color--red': this.grade < 5.5,
        'results-color--green': this.grade >= 5.5
      }
    },
    emotionsResults: function () {
      return {
        'emoticon--totally-agree': this.grade > 8,
        'emoticon--agree': this.grade >= 6 && this.grade <= 8,
        'emoticon--neutral': this.grade >= 5 && this.grade < 6,
        'emoticon--disagree': this.grade >= 3 && this.grade < 5,
        'emoticon--totally-disagree': this.grade >= 1 && this.grade < 3,
      }
    }
  },
  methods: {
    getOwnGrade: function () {

      // A reference to the users collection.
      const users = database.collection('werkgeluk_test');
      const user = users.doc(this.uid);

      user.get().then((documentSnapshot) => {
        if (documentSnapshot.exists) {
          const data = documentSnapshot.data();
          this.ownGrade = data.happiness_job;
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    },
    smoothScroll: function () {
      Array.from(document.querySelectorAll('a[href^="#"]')).forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();

          document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
          });
        });
      });
    },
    onScroll: function () {
      let tip = document.querySelectorAll(".tip");
      let tips = {};
      let i = 0;

      Array.prototype.forEach.call(tip, function (e) {
        tips[e.id] = e.offsetTop;
      });

      let scrolledDiv = document.querySelector(".right");

      scrolledDiv.onscroll = function () {
        let scrollPosition = scrolledDiv.scrollTop;

        for (i in tips) {
          if (tips[i] <= scrollPosition) {

            var selection = document.querySelector('.menu-tips a[href*=' + i + ']') !== null;
            if (selection) {
              document.querySelector('.active').setAttribute('class', ' ');
              document.querySelector('a[href*=' + i + ']').setAttribute('class', 'active');
            }

          }
        }
      };
    },
    mouseClick: function (tipId) {
      setTimeout(() => this.tipActive = tipId, 750);
    },
    getParts: function () {
      var parts = [];

      // 2. Get results data.
      var obj = this.results;

      Object.keys(obj).forEach(key => {

        var val = obj[key];
        var questions = val.questions;
        var part = val.part;
        var question_total = 0;

        // 3. Count per part the questions total score.
        Object.keys(questions).forEach(questions_key => {
          var question = questions[questions_key];
          if (this.user_data[question]) {
            var score = this.user_data[question];
            question_total += Number(score);
          }
        })
        parts[part] = question_total;
      })

      var results_html = [];

      var results = this.results;
      Object.keys(results).forEach(result_key => {
        var value = results[result_key];
        var score = parts[value.part];

        var scores = value.scores;
        Object.keys(scores).forEach(scores_key => {
          var value_score = scores[scores_key];
          if (score >= value_score.min && score <= value_score.max) {
            var result_data = [];
            result_data['title'] = value_score.title;
            result_data['description'] = value_score.description;
            this.results_html.push(result_data);

          }
        })
      })
      this.$nextTick(() => {
        this.onScroll();
        const grade = this.grade;
        const name = this.name;
        document.querySelectorAll('.tip').forEach(function (el) {
          let data = el.innerHTML;
          data = data.replace(/\[name\]/g, name);
          data = data.replace(/\[grade\]/g, grade);
          el.innerHTML = data;
        });
      })
    },
    getSumPerChapter: function () {

      // 1. Get user data.
      const users = database.collection('werkgeluk_test');
      const user = users.doc(this.uid);
      user.get().then((documentSnapshot) => {
        if (documentSnapshot.exists) {
          const data = documentSnapshot.data();
          this.user_data = data.answers;
          this.name = data.personal.name;
          this.getParts();
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  mounted() {
    fetch(projects[0]['test']['results'] + '?v=' + Date.now()).then(r => r.json()).then(json => {
      this.results = json;
    }).then();

    fetch(projects[0]['test']['settings'] + '?v=' + Date.now()).then(r => r.json()).then(json => {
      this.settingsLeftTop = json[0]['results'][0]['leftTop'];
      this.settingsLeftBottom = json[0]['results'][0]['leftBottom'];
      this.settingsRightTop = json[0]['results'][0]['rightTop'];
      this.settingsRightBottom = json[0]['results'][0]['rightBottom'];
      this.settingsNextTip = json[0]['results'][0]['nextTip'];
      this.settingsShowTip = json[0]['results'][0]['showTip'];
    });

    this.toggleBodyClass('addClass', 'results');
    this.getGrade();
    this.getSumPerChapter();
    this.smoothScroll();
  },
  destroyed() {
    this.toggleBodyClass('removeClass', 'results');
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Results.vue